import { Actor, Color, EmitterType, ParticleEmitter, vec } from 'excalibur';

export class ExplosionParticles extends Actor {
    constructor(x: number, y: number, color: Color = Color.Orange) {
        super({ pos: vec(x, y), z: 100 });

        // Configure the emitter for a "burst" effect
        // v0.32.0+ change: Particle properties are now nested in a 'particle' config object
        const emitter = new ParticleEmitter({
            emitterType: EmitterType.Circle, // Emit in all directions
            radius: 0,                       // Start from a single point
            isEmitting: true,                // Start immediately
            emitRate: 300,                   // High rate for sudden burst
            particle: {
                minSpeed: 50,                // RENAME: minVel -> minSpeed
                maxSpeed: 200,               // RENAME: maxVel -> maxSpeed
                minAngle: 0,
                maxAngle: Math.PI * 2,
                life: 800,                   // RENAME: particleLife -> life
                beginColor: color,
                endColor: Color.Transparent,
                opacity: 1,
                fade: true,                  // RENAME: fadeFlag -> fade
            }
        });

        this.addChild(emitter);

        // Logic to stop the emitter and remove the actor
        // 1. Emit for 100ms (short burst)
        // 2. Stop emitting
        // 3. Wait for particles to finish their life (800ms)
        // 4. Remove this Actor from the scene
        this.actions
            .delay(100)
            .callMethod(() => {
                emitter.isEmitting = false;
            })
            .delay(800)
            .die();
    }
}
